import insertAtCaret from '../util/insert_at_caret'

up.compiler('[templatable]', (element, { templatesPath }) => {
  const textarea = element.querySelector('textarea')
  if (textarea.disabled) return

  const opener = up.element.createFromHTML(`
    <button type="button" class="btn btn-light btn-sm ms-2 float-end" style="translate: 0 -2px;">
      Textbaustein einfügen
    </button>
  `)

  function onClickOpener() {
    up.layer.open({
      url: templatesPath,
      mode: 'modal',
      size: 'large',
      focus: '[name*="query"]',
      history: false,
      onAccepted: function({ value }) { insertAtCaret(textarea, value) },
    })
  }

  opener.addEventListener('click', onClickOpener)
  element.prepend(opener)
})
